import { createContext, useContext, useReducer } from "react";

const UserDataStateContext = createContext(undefined);
const UserDataUpdaterContext = createContext(undefined);

const UserDataReducer = (state, action) => {
  switch (action.type) {
    case "initialize": {
      return state;
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};
const UserDataProvider = ({ children }) => {
  const [state, dispatch] = useReducer(UserDataReducer, {
    /* fill in intitial state */
  });
  return (
    <UserDataStateContext.Provider value={state}>
      <UserDataUpdaterContext.Provider value={{ dispatch }}>{children}</UserDataUpdaterContext.Provider>
    </UserDataStateContext.Provider>
  );
};

const useUserData = () => {
  const context = useContext(UserDataStateContext);
  if (context === undefined) {
    throw new Error("useUserData must be used within a UserDataProvider");
  }
  return context;
};

const useUserDataDispatch = () => {
  const context = useContext(UserDataUpdaterContext);
  if (context === undefined) {
    throw new Error("useUserDataDispatch must be used within a UserDataUpdaterProvider");
  }
  return context;
};
export { UserDataProvider, useUserData, useUserDataDispatch };
